import { routesData } from './routes.constant';

export const routesBackLanding = [
  routesData.HOME.redirectPath,
  routesData.OTP.redirectPath,
  routesData.PERSONAL_INFORMATION.redirectPath,
  routesData.ECONOMIC_ACTIVITY.redirectPath,
  routesData.ACCOUNT_SETTINGS.redirectPath,
  routesData.CARD_MANAGEMENT_MEDIA.redirectPath,
  routesData.ERRORS.USER_ERROR.redirectPath,
  routesData.ERRORS.GENERAL_ERROR.redirectPath,
  routesData.ERRORS.OTP_ERROR.redirectPath,
  routesData.ERRORS.SUMMARY_ERROR.redirectPath,
  routesData.ERRORS.SUMMARY_PSE_ERROR.redirectPath,
  routesData.USER_IDENTIFICATION.redirectPath,
  routesData.PUBLICY_EXPOSED_PERSON.redirectPath,
  routesData.CDT_CONFIGURATION.redirectPath,
  routesData.CONTACT_INFORMATION.redirectPath,
  routesData.FINANTIAL_INFORMATION.redirectPath,
  routesData.FOREIGN_CURRENCY_MOVEMENTS.redirectPath,
  routesData.NONDECLARATING_QUESTION.redirectPath,
  routesData.DIGITAL_SIGNATURE.redirectPath,
  routesData.CHANNEL_ENROLLMENT.redirectPath,
  routesData.SAVING_TIPS.redirectPath,
  routesData.PRODUCT_SUMMARY.redirectPath,
  routesData.PSE.redirectPath
];
